import { Box, Typography, Button, useTheme, alpha } from "@mui/material";
import { ShoppingCartOutlined, ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { memo } from "react";
import { CONFIG } from "../../config";

const BuyDeviceBanner = memo(() => {
  const theme = useTheme();
  const { t } = useTranslation("common");

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      sx={{
        borderRadius: 3,
        p: 3,
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative gradient orb */}
      <Box
        sx={{
          position: "absolute",
          top: -60,
          right: -60,
          width: 180,
          height: 180,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${alpha(
            theme.palette.common.white,
            0.18
          )} 0%, transparent 70%)`,
          pointerEvents: "none",
        }}
      />

      <Box display="flex" alignItems="center" gap={2} sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            backgroundColor: alpha(theme.palette.common.white, 0.2),
            borderRadius: "50%",
            width: 56,
            height: 56,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.common.white,
            flexShrink: 0,
          }}
        >
          <ShoppingCartOutlined fontSize="medium" />
        </Box>
        <Box>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{ color: theme.palette.primary.contrastText }}
          >
            {t("common.need_to_purchase_new_device")}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: alpha(theme.palette.primary.contrastText, 0.85) }}
          >
            {t("common.get_started_purchase_device")}
          </Typography>
        </Box>
      </Box>

      <Button
        variant="contained"
        size="large"
        component="a"
        href={CONFIG.buy_link}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<ArrowForward />}
        sx={{
          position: "relative",
          zIndex: 1,
          flexShrink: 0,
          fontWeight: 600,
          px: 3,
          backgroundColor: theme.palette.common.white,
          color: theme.palette.primary.dark,
          "&:hover": {
            backgroundColor: alpha(theme.palette.common.white, 0.9),
          },
        }}
      >
        {t("common.visit_shop")}
      </Button>
    </Box>
  );
});

BuyDeviceBanner.displayName = "BuyDeviceBanner";

export default BuyDeviceBanner;
